import { render } from "./boot.vue?vue&type=template&id=31bb3100&scoped=true"
import script from "./boot.vue?vue&type=script&lang=js"
export * from "./boot.vue?vue&type=script&lang=js"

import "./boot.vue?vue&type=style&index=0&id=31bb3100&scoped=true&lang=scss"

import exportComponent from "C:\\Projects\\BijouCRM\\src\\ui\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31bb3100"]])

export default __exports__